<template>
  <div>
   <div id="container"></div>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
   var Transfer;
      var driving;
      var Riding;
      var walking;
export default {
  name: "map-view",
  props:['position'],
  data(){
    return {
      data: {
        lng: globalConfig.lng,
        lat: globalConfig.lat,
      },
      map: null,
 
    }
  },
  mounted() {
    this.initData();
    this.initAMap();
  },
  beforeDestroy() {
    if(this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initData() {
      if(this.position) {
        if(this.position.lng) {
          this.data.lng = this.position.lng;
        }
        if(this.position.lat) {
          this.data.lat = this.position.lat;
        }
      }
    },
    clearmap(){
        walking.clear()


    },
    routePlan(startPlace, destPlace,tftype) {
      // 出发地或目的地为空直接返回
      if(!startPlace || !destPlace) {
        return;
      }
     const points = [
         { keyword: startPlace, city: "全国" },
         { keyword: destPlace, city: "全国" },
     ];
     const map = this.map;
   
     if(Transfer)
     {
       Transfer.clear()
     }
     if(driving)
     {
      driving.clear()
     }
     if(Riding)
     {
      Riding.clear()
     }
     if(walking)
     {
      walking.clear()
     }
    if(tftype===1)
    { 
     
      AMap.plugin(["AMap.Transfer"],function(){
     

        
        
         Transfer = new AMap.Transfer({
        map: map,
        // panel: "res", //参数值为你页面定义容器的 id 值<div id="my-panel"></div>
        autoFitView:true
    });
  
  //获取起终点规划线路
   Transfer.search(points, function (status, result) {
    if (status === "complete") {
   
      console.log(result);
    } else {
      console.log("获取驾车数据失败：" + result);
    }
  });




      })
    }
    else if(tftype===2)
    {
          AMap.plugin(["AMap.Driving"],function(){
     

       
        driving = new AMap.Driving({
        map: map,
        // panel: "res", //参数值为你页面定义容器的 id 值<div id="my-panel"></div>
        autoFitView:true
    });
  
  //获取起终点规划线路
   driving.search(points, function (status, result) {
    if (status === "complete") {
   
      console.log(result);
    } else {
      console.log("获取数据失败：" + result);
    }
  });
  })
    }
    else if(tftype===3)
    {
        AMap.plugin(["AMap.Riding"],function(){
     

       
        Riding = new AMap.Riding({
        map: map,
        // panel: "res", //参数值为你页面定义容器的 id 值<div id="my-panel"></div>
        autoFitView:false
    });
  
  
  //获取起终点规划线路
   Riding.search(points);
  })

    }
    else if(tftype===4)
    {
      
       AMap.plugin(["AMap.Walking"],function(){

          
           walking=new AMap.Walking({
                 map: map,
                //  panel: "res", //参数值为你页面定义容器的 id 值<div id="my-panel"></div>
                 autoFitView:true


           })
     
       walking.search(points,function (status, result){
             if (status === "complete") {
   
                  console.log(result);
            } else {
              // console.log("获取数据失败：" + result);
              alert("超出步行最大范围，请采用公交和自驾方式")

            }
 

       })


       })


    }

  },
    
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: globalConfig.amapSecuretKey,
      };
      AMapLoader.load({
        key: globalConfig.amapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "2D", // 是否为3D地图模式
            zoom: 16, // 初始化地图级别
            center: [this.data.lng, this.data.lat], // 初始化地图中心点位置
          });

          const markerContent = `<div class="custom-content-marker">
            <img src="//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png" width="30">
            </div>`
          const position = new AMap.LngLat(this.data.lng, this.data.lat); //Marker 经纬度
          const marker = new AMap.Marker({
            position: position,
            content: markerContent, //将 html 传给 content
            offset: new AMap.Pixel(-13, -30), //以 icon 的 [center bottom] 为原点
          });

          this.map.add(marker)
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style scoped>
  #container {
    width: 100%;
    height: 800px;
  }

  .custom-content-marker {
    position: relative;
    width: 25px;
    height: 34px;
  }

  .custom-content-marker img {
    width: 100%;
    height: 100%;
  }

  .custom-content-marker .close-btn {
    position: absolute;
    top: -6px;
    right: -8px;
    width: 15px;
    height: 15px;
    font-size: 12px;
    background: #ccc;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 15px;
    box-shadow: -1px 1px 1px rgba(10, 10, 10, .2);
  }

  .custom-content-marker .close-btn:hover{
    background: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/AMapContainer.vue